/* ------------------------------------------------------------------------------
 *
 *  # Seguimiento de Actividades Component
 *
 *  Module for managing student activity tracking matrix
 *
 * ---------------------------------------------------------------------------- */

// Callbacks para interacción con Blazor
let blazorCallbacks = {
    onEstadoChanged: null,
    onCategoriaToggled: null
};

/**
 * Set callbacks for Blazor interop
 */
export function setSeguimientoActividadesCallbacks(callbacks) {
    blazorCallbacks = { ...blazorCallbacks, ...callbacks };
}

/**
 * Initialize week picker
 */
export function initWeekPicker(inputId, currentWeek, currentYear, dotNetRef) {
    const input = document.getElementById(inputId);
    if (!input) {
        console.warn(`Week picker input ${inputId} not found`);
        return;
    }

    // Set initial value
    input.value = `${currentYear}-W${String(currentWeek).padStart(2, '0')}`;

    // Handle change event
    input.addEventListener('change', function(e) {
        const value = e.target.value; // Format: "2025-W10"
        const [year, week] = value.split('-W');
        
        if (dotNetRef) {
            dotNetRef.invokeMethodAsync('OnWeekChanged', parseInt(week), parseInt(year));
        }
    });
}

/**
 * Update activity status (radio button change)
 */
export function updateEstado(estudianteId, actividadId, estadoId, semana, anio, dotNetRef) {
    if (blazorCallbacks.onEstadoChanged) {
        blazorCallbacks.onEstadoChanged(estudianteId, actividadId, estadoId, semana, anio);
    }

    if (dotNetRef) {
        dotNetRef.invokeMethodAsync('OnEstadoChanged', estudianteId, actividadId, estadoId, semana, anio)
            .then(success => {
                if (success) {
                    showSavedIndicator(actividadId);
                } else {
                    showErrorIndicator(actividadId);
                }
            })
            .catch(err => {
                console.error('Error updating estado:', err);
                showErrorIndicator(actividadId);
            });
    }
}

/**
 * Show saved indicator (green checkmark animation)
 */
export function showSavedIndicator(actividadId) {
    const indicator = document.getElementById(`saved_${actividadId}`);
    if (indicator) {
		new Noty({
			text: 'Información guardada correctamente.',
			type: 'success'
		}).show();
    }
}

/**
 * Show error indicator (red X animation)
 */
export function showErrorIndicator(actividadId) {
    const indicator = document.getElementById(`error_${actividadId}`);
    if (indicator) {
        indicator.style.display = 'inline-block';
        indicator.classList.add('shake');
        
        setTimeout(() => {
            indicator.classList.remove('shake');
            indicator.style.display = 'none';
        }, 2000);
    }
}

/**
 * Toggle categoria collapsible
 */
export function toggleCategoria(categoriaId) {
    const element = document.getElementById(`collapse_${categoriaId}`);
    if (element) {
        const bsCollapse = new bootstrap.Collapse(element);
        
        if (blazorCallbacks.onCategoriaToggled) {
            const isExpanded = element.classList.contains('show');
            blazorCallbacks.onCategoriaToggled(categoriaId, !isExpanded);
        }
    }
}

/**
 * Expand all categories
 */
export function expandAllCategorias() {
    document.querySelectorAll('[id^="collapse_"]').forEach(element => {
        const bsCollapse = bootstrap.Collapse.getOrCreateInstance(element);
        bsCollapse.show();
    });
}

/**
 * Collapse all categories
 */
export function collapseAllCategorias() {
    document.querySelectorAll('[id^="collapse_"]').forEach(element => {
        const bsCollapse = bootstrap.Collapse.getOrCreateInstance(element);
        bsCollapse.hide();
    });
}

/**
 * Apply search filter
 */
export function applySearch(searchTerm) {
    const lowerSearch = searchTerm.toLowerCase();
    
    document.querySelectorAll('.actividad-row').forEach(row => {
        const actividadName = row.querySelector('.actividad-nombre')?.textContent.toLowerCase() || '';
        const categoriaName = row.querySelector('.categoria-nombre')?.textContent.toLowerCase() || '';
        
        const matches = actividadName.includes(lowerSearch) || categoriaName.includes(lowerSearch);
        row.style.display = matches ? '' : 'none';
    });
    
    // Hide empty categories
    document.querySelectorAll('.categoria-card').forEach(card => {
        const visibleRows = card.querySelectorAll('.actividad-row:not([style*="display: none"])');
        card.style.display = visibleRows.length > 0 ? '' : 'none';
    });
}

/**
 * Clear search filter
 */
export function clearSearch() {
    document.querySelectorAll('.actividad-row').forEach(row => {
        row.style.display = '';
    });
    
    document.querySelectorAll('.categoria-card').forEach(card => {
        card.style.display = '';
    });
    
    const searchInput = document.getElementById('searchActividades');
    if (searchInput) {
        searchInput.value = '';
    }
}

/**
 * Get current week number
 */
export function getCurrentWeek() {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const days = Math.floor((now - startOfYear) / (24 * 60 * 60 * 1000));
    return Math.ceil((days + startOfYear.getDay() + 1) / 7);
}

///**
// * Export progress report
// */
//export function exportProgressReport(estudianteId, semana, anio) {
//    console.log(`Exporting progress report for student ${estudianteId}, week ${semana}, year ${anio}`);
//    // TODO: Implement export functionality
//}

///**
// * Apply filters from sidebar
// */
//export function applyFilters() {
//    const weekValue = document.getElementById('weekFilterActividades')?.value;
//    const presentado = document.getElementById('estadoPresentado')?.checked;
//    const practicando = document.getElementById('estadoPracticando')?.checked;
//    const progreso = document.getElementById('estadoProgreso')?.checked;
//	const dominado = document.getElementById('estadoDominado')?.checked;
//	const necesitaApoyo = document.getElementById('estadoNecesitaApoyo')?.checked;
//    const area = document.getElementById('areaFilter')?.value;

//    console.log('Applying filters:', { weekValue, presentado, practicando, progreso, dominado, necesitaApoyo, area });
//}

///**
// * Clear filters from sidebar
// */
//export function clearFilters() {
//    // Reset week to current
//    const weekInput = document.getElementById('weekFilterActividades');
//    if (weekInput) {
//        const now = new Date();
//        const weekNum = getCurrentWeek();
//        weekInput.value = `${now.getFullYear()}-W${String(weekNum).padStart(2, '0')}`;
//    }

//    // Reset checkboxes
//    ['estadoPresentado', 'estadoPracticando', 'estadoProgreso', 'estadoDominado', 'estadoNecesitaApoyo'].forEach(id => {
//        const checkbox = document.getElementById(id);
//        if (checkbox) checkbox.checked = true;
//    });

//    // Reset area filter
//    const areaFilter = document.getElementById('areaFilter');
//    if (areaFilter) areaFilter.value = '';

//    console.log('Filters cleared');
//}

//// Add CSS for animations
//const style = document.createElement('style');
//style.textContent = `
//    .fade-in {
//        animation: fadeIn 0.5s ease-in;
//    }
    
//    .fade-out {
//        animation: fadeOut 0.5s ease-out;
//    }
    
//    @keyframes fadeIn {
//        from { opacity: 0; transform: translateY(-10px); }
//        to { opacity: 1; transform: translateY(0); }
//    }
    
//    @keyframes fadeOut {
//        from { opacity: 1; }
//        to { opacity: 0; }
//    }
    
//    .shake {
//        animation: shake 0.5s;
//    }
    
//    @keyframes shake {
//        0%, 100% { transform: translateX(0); }
//        10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
//        20%, 40%, 60%, 80% { transform: translateX(5px); }
//    }
//`;
//document.head.appendChild(style);
